import { gql, TypedDocumentNode } from '@apollo/client'

import { DomainSliceDTO } from './types'

export const DOMAIN_FOR_SELECT_FRAGMENT: TypedDocumentNode<DomainSliceDTO> = gql`
  fragment DomainForSelectFragment on Domain {
    id
    name
  }
`
